export abstract class LogRow {
    protected readonly _properties: Record<string, unknown>;
    constructor(properties: Record<string, unknown> | undefined) {
        this._properties = properties || {};
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public get properties(): Readonly<Record<string, any>> {
        return this._properties;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public abstract generateLoggingEntry(mergeAll?: boolean): Record<string, any>;

    public abstract pushToAppInsights(): void;

    public logToConsole(): void {
        // eslint-disable-next-line no-console
        console.log(this);
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public addToProperties(key: string, value: any): void {
        this._properties[key] = value;
    }

    /**
     * (For AI 1.x) Gets the property object whose values are converted into string.
     */
    protected getStringifiedProperties(): Record<string, string> {
        const result: Record<string, string> = {};
        for (const k in this._properties) {
            const v = this._properties[k];
            try {
                result[k] = typeof v === 'object' ? stringifyObject(v) : String(v);
            } catch (err) {
                result[k] = `Failed in getStringifiedProperties: [${err?.name}] ${err?.message}`;
            }
        }
        return result;
    }

}

function stringifyObject(obj?: {}): string {
    if (!obj) {
        return String(obj);
    }
    if (obj instanceof Error) {
        // Note that Error members are not enumerable. JSON.stringify(obj) results in "{}"."
        return JSON.stringify({
            name: obj.name,
            message: obj.message,
            stack: obj.stack, ...obj
        });
    }
    return JSON.stringify(obj);
}
